import { css, jsx } from '@emotion/core';
import { Input } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: (bool = false) => css`
    width: 100%;
    margin: 1.6rem 0;
    display: ${bool ? 'none' : 'block'};
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border: 1px solid ${colors.accentGrayMedium};
      background-color: ${colors.white};
    }
    .has-error .ant-input {
      border-color: #aa2d2a;
    }
  `,
};

const TextInput = ({ form, info, updateProfile, currentInfo, key, onChange }) => {
  const { label, persist, meta, field, formOverrides = {}, isMailing, extra } = info;
  const { isMailingAddressDisabled } = updateProfile;
  const isFieldVisible = Boolean(isMailing) && isMailingAddressDisabled;
  // console.log({isMailing: {isFieldVisible}})
  return (
    <div key={key} css={styles.inputContainer(isFieldVisible)}>
      {info.hidden ? (
        <Form.Item label={label} extra={extra}>
          {form.getFieldDecorator(field, {
            initialValue: updateProfile[field],
            ...formOverrides,
          })(
            <Input.Password
              visibilityToggle={false}
              onChange={e => {
                onChange(field, e);
              }}
              value={currentInfo}
              size="large"
            />
          )}
        </Form.Item>
      ) : (
        <Form.Item label={label} extra={extra}>
          {form.getFieldDecorator(field, {
            initialValue: updateProfile[field],
            ...formOverrides,
            ...(Boolean(isMailing) &&
              isMailingAddressDisabled && {
                rules: [{ required: false }],
              }),
          })(
            <Input
              size="large"
              disabled={Boolean(isMailing) && isMailingAddressDisabled}
              onChange={e => {
                onChange(field, e);
              }}
            />
          )}
        </Form.Item>
      )}
    </div>
  );
};

const mapStateToProps = ({ updateProfile }) => {
  return {
    updateProfile,
  };
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
  isMailing: false,
};
export default connect(
  mapStateToProps,
  {}
)(TextInput);
